import { Box, HStack } from '@chakra-ui/react'
import React, { useRef } from 'react'

import TabItemComponent from './TableItemComponent'

interface TabItem {
  title: string
  path?: string
  tab: string
}

interface NavigationTabProps {
  selectedTab: string
  onSelectTab?: (tab: string, path?: string) => void
  tabItems: TabItem[]
  questionnaire?: boolean
  rightContent?: React.ReactNode
}

const NavigationTab: React.FC<NavigationTabProps> = ({ selectedTab, onSelectTab, tabItems, questionnaire = false, rightContent }) => {
  const tabRef = useRef<HTMLDivElement>(null)
  return (
    <Box
      ref={tabRef}
      flexDirection="column"
      w={questionnaire ? 'auto' : '100%'}
      height={questionnaire ? '44px' : 'auto'}
      mb='6px'
    >
      <HStack
        spacing="8px"
        align="center"
        overflowX={{ base: 'auto', md: 'visible' }}
        overflowY="hidden"
        h="100%"
        py="6px"
        px={{ base: '12px', md: '0px' }}
        css={{
          '&::-webkit-scrollbar': { display: 'none' },
          scrollbarWidth: 'none',
        }}
      >
        {tabItems.map((item) => (
          <TabItemComponent
            key={item.tab}
            title={item.title}
            path={item.path}
            tab={item.tab}
            selected={selectedTab === item.tab}
            onSelectTab={onSelectTab}
          />
        ))}
        {rightContent && <Box ml="auto">{rightContent}</Box>}
      </HStack>
    </Box>
  )
}

export { NavigationTab as default }

